{
  "completed": "已完成：",
  "current": "当前：",
  "notCompleted": "未完成：",
  "steplist": "步骤列表"
}
